import { atom } from "jotai";
import { atomFamily } from "jotai/utils";

import { groupNodeCreateStartAtom, isDraggingNodeAtom } from "../diagramming";
import { singleSelectedNodeIdAtom } from "./singleSelectedNodeAtoms";

export const isOnlyNodeSelectedAtomFamily = atomFamily((nodeId: string) => {
  const isOnlyNodeSelectedAtom = atom((get) => {
    const isDraggingNode = get(isDraggingNodeAtom);
    const groupNodeCreateStart = get(groupNodeCreateStartAtom);

    if (isDraggingNode || groupNodeCreateStart) {
      return false;
    }

    const singleSelectedNodeId = get(singleSelectedNodeIdAtom);
    return singleSelectedNodeId === nodeId;
  });

  isOnlyNodeSelectedAtom.debugLabel = `isOnlyNodeSelectedAtomFamily(${nodeId})`;
  return isOnlyNodeSelectedAtom;
});
